import React, { useState } from 'react';
import styles from './DescriptionRentalTermsTabs.module.css';
import classNames from 'classnames';
import { IconCollection, FAQ } from '../../../components';
import { normalizeString } from '../../../util/data';

export default function DescriptionRentalTermsTabs({ description, rentalTerms, faqs }) {
    const [activeTab, setActiveTab] = useState('description');

    return (
        <div className={styles.panel}>
            <div className={styles.tabs}>
                <div
                    className={`${styles.tab} ${activeTab === 'description' ? styles.active : ''}`}
                    onClick={() => setActiveTab('description')}
                >
                    Description
                </div>
                <div
                    className={`${styles.tab} ${activeTab === 'rentalTerms' ? styles.active : ''}`}
                    onClick={() => setActiveTab('rentalTerms')}
                >
                    Rental Terms
                </div>
                <div
                    className={`${styles.tab} ${styles.mobileOnly} ${activeTab === 'faq' ? styles.active : ''}`}
                    onClick={() => setActiveTab('faq')}
                >
                    FAQ
                </div>
            </div>
            <div className={styles.tabContent}>
                {activeTab === 'description' ? (
                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
                ) : activeTab === 'rentalTerms' ? (
                    <div className={styles.terms}>
                        <div className={styles.termRow}>
                            <span className={styles.termLabel}>Cash Security Deposit</span>
                            <span className={styles.termValue}>{normalizeString(rentalTerms?.cashSecurityDeposit)}</span>
                        </div>
                        <div className={styles.termRow}>
                            <span className={styles.termLabel}>Cancelation Policy</span>
                            <span className={styles.termValue}>{normalizeString(rentalTerms?.cancelationPolicy)}</span>
                        </div>
                        <div className={classNames(styles.termRow,styles.termWithItem)}>
                            <span className={styles.termLabel}>Rental Accessibility</span>
                            <span className={styles.termValue}>
                                {rentalTerms?.rentalAccessibility?.map((item, i) => (
                                    <span className={styles.checkItem} key={i}>
                                        <span className={styles.checkIcon}><IconCollection name="advice_check" /></span> {normalizeString(item)}
                                    </span>
                                ))}
                            </span>
                        </div>
                        <div className={classNames(styles.termRow,styles.termWithItem)}>
                            <span className={styles.termLabel}>Trust & Verification Requirements</span>
                            <span className={styles.termValue}>
                                {Array.isArray(rentalTerms?.trustVerification) ? (
                                    rentalTerms.trustVerification.map((item, i) => (
                                        <span className={styles.checkItem} key={i}>
                                            <span className={styles.checkIcon}><IconCollection name="advice_check" /></span> {normalizeString(item)}
                                        </span>
                                    ))
                                ) : (
                                    rentalTerms?.trustVerification &&
                                        <span className={styles.checkItem}>
                                            <span className={styles.checkIcon}><IconCollection name="advice_check" /></span> {normalizeString(rentalTerms?.trustVerification)}
                                        </span>
                                    
                                )}
                            </span>
                        </div>
                        <div className={classNames(styles.termRow,styles.termWithItem)}>
                            <span className={styles.termLabel}>Reason For Renting</span>
                            <span className={styles.termValue}>
                                {rentalTerms?.reasonForRenting?.map((item, i) => (
                                    <span className={styles.checkItem} key={i}>
                                        <span className={styles.checkIcon}><IconCollection name="advice_check" /></span> {normalizeString(item)}
                                    </span>
                                ))}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className={styles.faqContent}>
                        {faqs && faqs.length > 0 && <FAQ faq={faqs} />}
                    </div>
                )}
            </div>
        </div>
    );
}